//Angular
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

//Externos
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";

//Componentes
import { MyQrsCatalogComponent } from "./components/my-qrs-catalog/my-qrs-catalog.component";
import { CardComponent } from "./components/card/card.component";
import { ModalCourseCardComponent } from "./components/modal-course-card/modal-course-card.component";
import { LoadingSpinnerModule } from "src/app/shared/spinner/loading-spinner.module";
import { SharedModule } from "../shared/shared.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MaterialModule } from "../material.module";
import { MyQrsMainPageComponent } from "./pages/my-qrs-main-page/my-qrs-main-page.component";
import { MyQrFiltersComponent } from "./components/my-qr-filters/my-qr-filters.component";
import { ModalShareQRCardComponent } from "./components/modal-share-qr-card/modal-share-qr-card.component";
import { ShareQrsCatalogComponent } from "./components/share-qrs-catalog/share-qrs-catalog.component";
import { ModalShareQrAttendanceComponent } from "./components/modal-share-qr-attendance/modal-share-qr-attendance.component";
import { MyQrsCoursesCatalogRoutingModule } from "./myQrsCoursesCatalog-routing.module";
import { ModalShareQrFiltersComponent } from "./components/modal-share-qr-filters/modal-share-qr-filters.component";
import { MyQrFiltersGlobalComponent } from "./components/my-qr-filters-global/my-qr-filters-global.component";

@NgModule({
  declarations: [
    MyQrsCatalogComponent,
    CardComponent,
    ModalCourseCardComponent,
    MyQrsMainPageComponent,
    MyQrFiltersComponent,
    ModalShareQRCardComponent,
    ShareQrsCatalogComponent,
    ModalShareQrAttendanceComponent,
    ModalShareQrFiltersComponent,
    MyQrFiltersGlobalComponent,
  ],
  exports: [MyQrsCatalogComponent, CardComponent, ModalCourseCardComponent],
  imports: [
    CommonModule,
    NgxQRCodeModule,
    FormsModule,
    LoadingSpinnerModule,
    SharedModule,
    MyQrsCoursesCatalogRoutingModule,
    NgbModule,
    MaterialModule,
  ],
})
export class MyQrsCoursesCatalogModule {}
